import { RefObject, useState } from 'react';

interface Size {
  width: number;
  height: number;
}

/**
 * Measures the size of HTML elements including when they change
 *
 * @param target A React ref created by `useRef()` or an HTML element
 */
const useElementSize = <T extends HTMLElement>(target: RefObject<T>) => {
  const [size, setSize] = useState<Size>({ height: 0, width: 0 });
  let resizeObserver: ResizeObserver;

  const initialize = () => {
    resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      var entry = entries[0];
      setSize({
        height: entry.contentRect.height,
        width: entry.contentRect.width,
      });
    });

    if (target.current) {
      resizeObserver.observe(target.current as Element);
    }
  };

  const dispose = () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
  };

  return { size, initialize, dispose };
};

export default useElementSize;
